import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";
import { Icon } from "../../../lib/icon";
import Divider from "../../../lib/divider";
import React from "react";
import FormElement from "../../../forms/form_element";
import { shouldShowDecoupling } from "../../../../lib/feature_flag";
import GooglePlacesInput from "../../../forms/google_map_autocomplete";
export const HostsForm = ({ fields, hideSubtitle }) => {
  const addInput = () => {
    fields.push({
      ...(shouldShowDecoupling() && { postalAddress: {} }),
    });
  };
  const hostNameInputs = fields.map((host, index) => {
    return (
      <div key={index}>
        <HostFields
          host={host}
          onRemove={() => fields.remove(index)}
          fields={fields}
          index={index}
        />
        <Divider />
      </div>
    );
  });

  return (
    <div>
      {!hideSubtitle && (
        <div className="margin-bottom--large">
          Who are the hosts of your show? Include your mailing address so brands you advertise with
          can send you free product as part of the campaign.
        </div>
      )}

      {hostNameInputs}

      <div className="flex-row-container">
        <div className="flex-1" />
        <div className="primary-color bold pointer" onClick={addInput}>
          Add Host
        </div>
      </div>
    </div>
  );
};

const HostFields = ({ host, onRemove, fields, index }) => {
  return (
    <>
      <Row>
        <Col xs={11} md={6}>
          <Field
            type="text"
            className="form-control margin-bottom--small"
            component={FormElement}
            label={"First Name"}
            name={`${host}.fullName.firstName`}
          />
        </Col>
        <Col xs={11} md={6}>
          <Field
            component={FormElement}
            label={"Last Name"}
            name={`${host}.fullName.lastName`}
            type="text"
            className="form-control margin-bottom--small"
          />
        </Col>

        <Icon
          iconName="close"
          style={{ position: "absolute", marginTop: "15px", cursor: "pointer" }}
          onClick={onRemove}
        />
      </Row>
      {shouldShowDecoupling() && (
        <Field
          component={FormElement}
          InputComponent={GooglePlacesInput}
          label={"Address"}
          name={`${host}.postalAddress`}
        />
      )}
    </>
  );
};
